export default "__VITE_ASSET__GfhU4JBH__"